import React, { Component, Suspense } from 'react';
import renderHTML from 'react-render-html';
import Footer from './Footer';
import { backgroundImage, api, basic_api, get_json ,imagePath} from './common';
import { connect } from 'react-redux'
import Loader from './Loader'

import { useImage } from 'react-image'
// import { SuspenseImg } from "./SuspenseImg";


function MyImageComponent(props) {
  const { src } = useImage({
    srcList:imagePath+ props.Imagesrc.image
  })

  return (
    <div class="col-12 col-md-6 f-left blog-gidd">
      <div class="inner-bl-grid">
        <div class="post_featured">
          <div class="hvr-icnnn"><img className={"dsfsjf sd"} src={src} /></div>
        </div>
        <h4 class="bl-title">{props.Imagesrc.title}</h4>
        <div class="d-flx"><span class="post_info_date">By {props.Imagesrc.author_name} at {props.Imagesrc.created_at}</span></div>
        <div class="post_content clearfix">
          <p>{props.Imagesrc.description}</p>
        </div>
      </div>
    </div>
  )
}
function BgComponent(props) {
  const { src } = useImage({
    srcList: require('./images/newsletter.jpg')
  })
  return (
    <div className="headerImage" style={{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', height: 250, position: 'relative' }}>
      <div className="center_text">
        <h3 className="wthree_text_info">Blog</h3>
      </div>
    </div>
  )
}
class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], blog_data: this.props.blogRes, loader: true, error: false };
  }
  async componentDidMount() {

    window.scrollTo(0, 0)
    var data = new FormData();
    data.append("action", "get_blog_list")
    data.append("u_id", this.props.alldata.user_id)
    const requestOptions = {
      method: 'post',
      body: data
    };
    //if(this.props.blogRes.length!==0){this.setState({loader:false,blog_data:this.props.blogRes})}
    fetch(api + basic_api, requestOptions)
      .then((response) => response.json())
      .then(async (responseJson) => {
        console.log(responseJson, "blog")
        if (responseJson.success === "true") {
          await this.props.setblogRes(responseJson.data)
          await this.setState({ blog_data: responseJson.data, loader: false });
        }
        else {
          await this.setState({ error: true, loader: false });
        }
      })
      .catch((error) => {
        this.setState({ error: true, loader: false });
      });
  }
  render() {
    return (
      <div className="main_contact">

        <div className="blog-sec w-left">
          <div className="container">
          <div class="center_text">
                        <h3>Blog</h3>
                    </div>
            {(this.props.blogRes.length === 0) ?
              ['1', "2", "3", "4", "5", "6"].map(() => (
                <div className="col-12 col-md-6 f-left blog-gidd">
                  <div className="inner-bl-grid">
                    <div className="post_featured">
                      <div className="hvr-icnnn">
                        <img src="./React App_files/1614246890blog_1.png" />
                        <div className="place_effect showed">
                          <div className="img_div" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              ))
              :
              <Suspense fallback={<div class="row">
                {['1', "2", "3", "4", "5", "6"].map(() => (
                  <div className="col-12 col-md-6 f-left blog-gidd">
                    <div className="inner-bl-grid">
                      <div className="post_featured">
                        <div className="hvr-icnnn">
                          <img src="./React App_files/1614246890blog_1.png" />
                          <div className="place_effect showed">
                            <div className="img_div" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                ))}
              </div>}>
                <div class="row">
                  {this.state.blog_data.map((item, i) => (
                    <MyImageComponent className={"ff"} Imagesrc={item} index={i} />
                  ))}
                </div>
              </Suspense>

            }
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {

  return {
    alldata: state.responseJson,
    blogRes: state.blogRes
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setblogRes: (data) => dispatch({ type: "BLOG_RES", payload: data }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Blog);
// export default Blog;
